/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';

import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';

import * as $                 from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import {ServiceManager} from '@/services/service.manager';
import {ServiceLocator} from '@/services/service.locator';

import { OperationalMeasureDialogParams } from './operational.measure.dialog.params';

/**
 *
 * @class BatchRegressionDialog
 *
 * Dialog for gathering parameters needed to create a batch regression via BigQuery
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class BatchRegressionDialog extends Dialog {

  /** the name we're trying get from the user */
  // private name;

  /** the corridor we're trying get from the user */
  private corridor: string  = '';

  /** the start of the time bound */
  private start: string  = '';

  /** the end of the time bound */
  private end: string    = '';

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  /** standard constructor */
  constructor(host: ElementRef) {

    super(host);

    this.title = 'New Batch Regression';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[BatchRegressionDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    let br: BatchRegressionDialog = this;

    br.validator = validator ? validator : null;
    br.success   = success   ? success   : null;

    if (this.typingTimer) {

      clearTimeout(br.typingTimer);

      br.typingTimer = null;
    }

    Logger.debug('[BatchRegressionDialog] opening...');

    this.corridor = '';

    const body = $(br.host).find('.modal-body');

    const html = `
<div id="locomotive-fav-field" style="margin-top: 12px;">
  <label class="gui-label" style="width: 120px;">Select Corridor:</label>

  <select class="gui-input locomotive-fav-input fav-select"><option></option></select>
</div>


<div id="locomotive-start-field" style="margin-top: 12px;">
  <label class="gui-label" style="text-align: right; width: 60px;">Start:</label>
  <input class="gui-input locomotive-start-input" style="width: 200px;" type="text" placeholder="...">
</div>

<div id="locomotive-end-field" style="margin-top: 12px;">
  <label class="gui-label" style="text-align: right; width: 60px;">End:</label>
  <input class="gui-input locomotive-end-input" style="width: 200px;" type="text" placeholder="...">
</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* set the start picker */

    $('.locomotive-start-input').datepicker({

      dateFormat: 'yy-mm-dd',

      changeMonth: true,
      changeYear: true,

      onSelect: (date) => {

        /* jQuery datepicker uses format */

        Logger.debug(`[BatchRegressionDialog] new start: `, date);

        br.start = date;

        br.validate();
      }

    });

    /* set the end picker */

    $('.locomotive-end-input').datepicker({

      dateFormat: 'yy-mm-dd',

      changeMonth: true,
      changeYear: true,

      onSelect: (date) => {

        Logger.debug(`[BatchRegressionDialog] new end: `, date);

        br.end = date;

        br.validate();
      }

    });
    /* set up the FAV selection drop down */

    $('.fav-select').select2({

      placeholder:   `Please Wait...`,
      disabled:      true,
      allowClear:    false,
      closeOnSelect: true,
      width:         '200px',
      data:          []
    });

    /* add behaviors */

    setTimeout(() => {

      $(br.host).find('.opmeasure-name-input').focus();

      $(br.host).find('.opmeasure-name-input').on('input', (e) => {

        /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

        if (br.typingTimer) {

          clearTimeout(br.typingTimer);
        }

        br.typingTimer = setTimeout(() => {

          br.corridor = ($(e.currentTarget).val() as string).trim();

          br.validate();

        }, 400);

      });

      $(br.host).find('.opmeasure-name-input').on('keypress', (e) => {

        if (br.typingTimer) {

          clearTimeout(br.typingTimer);
        }

        br.typingTimer = setTimeout(() => {

          br.corridor = ($(e.currentTarget).val() as string).trim();

          if (e.key.toLowerCase() === 'enter') {

            br.validate(true);

            /* stop event propagation */

            return false;
          }

        }, 400);

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    br.validate();

    /* launch the data fill for the select2 dropdown (the FAV picker) */

    let sm: ServiceManager            = ServiceLocator.injector.get(ServiceManager);
    // sm.databridge.favList().then(
    sm.locoquery.corridorList().then(
      (result: string[]) => {

        Logger.debug(`[BatchRegressionDialog] configuring drop down: `, result);

        /*
         * format the data per select2 needs ...
         *
         * https://select2.org/data-sources/formats
         *
         */

        let data: any[] = [];

        result.forEach((item: string) => {

          data.push({
            "id": item,
            "text": item,
            "corridor": item
          });

        });

        /* sort the data by name ... */

        //data.sort((a, b) => {

        //  return a.text.localeCompare(b.text);
        //});

        /* set the combo box to this set of data */

        $('.fav-select').select2('destroy');

        $('.fav-select').select2({

          placeholder: `Select...`,
          disabled: false,
          allowClear: false,
          closeOnSelect: true,
          width: '200px',
          data
        });

        /* should be good to go for selecting... */

        $('.fav-select').on('select2:select', (e) => {

          br.corridor = e.params.data['corridor'];

          Logger.debug('[BatchRegressionDialog] Corridor picked: ', e.params.data['corridor']);

          br.validate();
        });

      },
      (error) => {

        Logger.error("[BatchRegressionDialog] could not fetch Corridor list: ", error);



      });
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    let br: BatchRegressionDialog = this;

    br.error('');

    /* assume its bad */

    br.disable();

    if (!br.validator) {

      /* at least make sure the name isn't empty */

      if (br.corridor === null) {

        const display = $(br.host).find('.gui-error-line');

        $(display).html('Must select a Corridor');

        return ;
      }

      if (br.start === '') {

        const display = $(br.host).find('.gui-error-line');

        $(display).html('Must select a start date');

        return ;
      }

      if (br.end === '') {

        const display = $(br.host).find('.gui-error-line');

        $(display).html('Must select an end date');

        return ;
      }

      br.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(br.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so it's ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        br.validator(new OperationalMeasureDialogParams({
          corridor:  br.corridor,
          start:     br.start,
          end:       br.end
         }),
         resolve,
         reject
        );

      }).then((value: OperationalMeasureDialogParams) => {

        br.enable();

        br.corridor = value.corridor;

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(br.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        br.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[BatchRegressionDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[BatchRegressionDialog] accepted: ', this.corridor);

    if (this.success) {

      /* inform the client */

      this.success({corridor: this.corridor, start: this.start, end: this.end});
    }

  }
}


